import { render, staticRenderFns } from "./mainRepair.vue?vue&type=template&id=13b6516d&scoped=true&"
import script from "./mainRepair.vue?vue&type=script&lang=js&"
export * from "./mainRepair.vue?vue&type=script&lang=js&"
import style0 from "./mainRepair.vue?vue&type=style&index=0&id=13b6516d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6516d",
  null
  
)

export default component.exports